import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import { Login, Home } from "pages";
import { Toaster } from "components";
import UpdateProfile from "pages/updateProfile";
import BillingPlans from "pages/billings_plans";
import MembershipCard from "pages/viewMembershipCard";
import ViewProfile from "pages/home/components/viewProfile";
import MembershipSelection from "pages/billings_plans/components/membershipSelection";
import ApplicationDetails from "pages/billings_plans/components/applicationDetails";
import PaymentResult from "pages/billings_plans/components/payment";
import CheckMembership from "pages/checkMembership/checkMembership";
import { ResetPassword } from "pages/login/resetPassword";
import { ConfirmPassword } from "pages/login/confirmPassword";
import MemebershipsList from "pages/memberships/membershipsList";
import MemebershipsDetails from "pages/memberships/membershipDetails";
import { CorperatorsList } from "pages/corperators/corperatorsList";

import { TermsConditions ,PrivacyPolicy, Permissions,PartnerWihUs } from "pages/settings/index";
import { Conformation } from "pages/memberships/conformation";
import { AboutUs } from "pages/settings/aboutUs";
import { PlansEdit,ShowPlansAll } from "pages/plans/index";
import { MembershipDetailsCard } from "pages/memberships/membershipDetailsCard";
import { UserDetailsEdit } from "pages/memberships/userDetailsEdit";
import { Adduser } from "pages/memberships/addUser";
import { AddPlan } from "pages/memberships";
import { ShowPartners } from "pages/partners/showPartners";
import { PartnerDetails } from "pages/partners/partnerDetails";
import { EditPartner } from "pages/partners/editPartner";
import { AddCorperators } from "pages/corperatesUser/addCorperators/addCorperators";
import { CorperatesUserList } from "pages/corperatesUser/corperatesUserList";
import { CorperatorsUserDetails } from "pages/corperators";
import { CorperatessDetails } from "pages/corperators/corperatesDetails";
import { PromocodesList, AddPromocode, EditPromocode, PromocodeDetails } from "pages/promocodes";
import { PartnerCategoriesList, AddPartnerCategory, EditPartnerCategory } from "pages/partnerCategories";
import { CitiesList, AddCity, EditCity } from "pages/cities";
import { ServicesList, AddService, EditService } from "pages/services";

function App() {
  return (
    <BrowserRouter>
      <Routes>
      <Route element={<Login />} path="*" />
        <Route element={<Login />} path="/" />
        {/* DashBoard */}
        <Route element={<Home />} path="/dashboard" />
        {/* plans */}
        <Route element={<ShowPlansAll />} path="/showplansall" />
        <Route element={<MembershipSelection />} path="/selectedPlan/:id" />
        <Route element={<PlansEdit />} path="/plansEdit/:id" />
        <Route element={<PlansEdit />} path="/addPlan" />
        <Route element={<AddPlan />} path="/addPlan/:userId" />
        {/* Memmberships */}
        <Route element={<MemebershipsList />} path="/memberships" />
        <Route element={<Adduser />} path="/addUser" />
        <Route element={<UserDetailsEdit />} path="/userDetailsEdit/:id"/>
        <Route element={<MemebershipsDetails />} path="/membershipDetails/:id" />
        <Route element={<Conformation />} path="/confirmation"/>
        <Route element={<MembershipDetailsCard />} path="/membershipDetailsCard/:id" />
        {/* Corperaters */}
        <Route element={<CorperatorsList />} path="/corporates" />
        <Route element={<CorperatessDetails />} path="/corperatesDetails/:id" />
        
        {/* Corperaters Users */}
        <Route element={<CorperatesUserList />} path="/corporatesUsers" />
        <Route element={<CorperatorsUserDetails />} path="/corporatesDetails/:id" />
        <Route element={<AddCorperators />} path="/addCorporates"/>

        {/* Settings */}
        <Route element={<PartnerWihUs />} path="/Partnerwithus" />
        <Route element={<TermsConditions />}  path="/termsConditions"/>
        <Route element={<PrivacyPolicy />} path="/PrivacyPolicy" />
        <Route element={<AboutUs />}  path="/aboutUs"/>
        <Route element={<Permissions />} path="/permissions" /> 
        {/* Partners */}
        <Route element={<ShowPartners />} path="/partners" />
        <Route element={<PartnerDetails />} path="/partnersDetails/:id" />
        <Route element={<EditPartner />} path="/addPartner" />
        <Route element={<EditPartner />} path="/editPartner/:id" />
        {/* Partner Categories */}
        <Route element={<PartnerCategoriesList />} path="/partnerCategories" />
        <Route element={<AddPartnerCategory />} path="/addPartnerCategory" />
        <Route element={<EditPartnerCategory />} path="/editPartnerCategory/:id" />
        {/* Cities */}
        <Route element={<CitiesList />} path="/cities" />
        <Route element={<AddCity />} path="/addCity" />
        <Route element={<EditCity />} path="/editCity/:id" />
        {/* Promocodes */}
        <Route element={<PromocodesList />} path="/promocodes" />
        <Route element={<AddPromocode />} path="/addPromocode" />
        <Route element={<EditPromocode />} path="/editPromocode/:id" />
        <Route element={<PromocodeDetails />} path="/promocodeDetails/:id" />
        {/* Services */}
        <Route element={<ServicesList />} path="/services" />
        <Route element={<AddService />} path="/addService" />
        <Route element={<EditService />} path="/editService/:id" />
        {/*  */}
        <Route element={<BillingPlans />} path="/billingplans/:id" />
        <Route element={<PaymentResult />} path="/payment/:id" />
        <Route element={<ApplicationDetails />} path="/membershipForm/:id" />
        <Route element={<MembershipCard />} path="/membershipcard" />
        <Route element={<CheckMembership />} path="/checkMembership" />
        <Route element={<ResetPassword />} path="/restPassword" />
        <Route element={<ConfirmPassword />} path="/setPassword/:id" />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
